var googleMapsApiManager = (function(){
    let promise;
    function init(){
        if(promise) return promise;
        promise = new Promise((resolve, reject) => {
            window.__gmapsResolve = resolve;
            const s = document.createElement('script');
            s.src = `https://maps.googleapis.com/maps/api/js?key=${ENV.gMapsApiKey}&libraries=places&callback=__gmapsResolve`;
            s.async = true;
            s.onerror = reject;
            document.head.appendChild(s);
        });

        return promise;
    }

    return {
        init:init
    }
})(jQuery)